import React from 'react'
import styled, { css } from 'styled-components'
import { node, string, bool } from 'prop-types'
import { rgba, stripUnit } from 'polished'
import { SLIDESHOW_SPEED } from 'utils/constants'

import { media, mediaDown } from 'styles/media'
import { white, black } from 'styles/colors'
import { H3 } from 'styles/typography'
import * as spacing from 'styles/spacing'
import { navHeightMobile, animationTime, animationCurve } from 'styles/global'

import Portal from 'components/Portal'
import MobileNav from 'components/MobileNav'
import Button from 'components/button/Button'

const Container = styled.div`
  position: fixed;
  bottom: 5vw;
  right: 5vw;
  z-index: 50;

  ${mediaDown.medium`
    top: 0;
    left: 0;
    bottom: auto;
    right: 0;
    height: ${navHeightMobile};
    box-shadow: 0 1px 0 0 ${props => (props.isDark ? rgba(white, 0.25) : rgba(black, 0.1))};
    background-color: ${props => (props.isDark ? rgba(black, 0.1) : rgba(black, 0.05))};
    backdrop-filter: blur(8px);
    opacity: 0;
    visibility: hidden;
    transition: opacity ${SLIDESHOW_SPEED} ease-in-out, visibility ${SLIDESHOW_SPEED} ease-in-out;

    ${props =>
      props.visibility &&
      css`
        background-color: ${props => (props.isDark ? rgba(black, 0.2) : rgba(black, 0.15))};
      `};

    body:not(.fp-viewing-step-1) & {
      opacity: 1;
      visibility: visible;
    }
  `};
`

const Inner = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  ${mediaDown.medium`
    height: ${navHeightMobile};
    justify-content: space-between;
    padding-left: ${spacing.large};
    padding-right: ${spacing.medium};
  `};
`

const Price = styled(H3)`
  color: ${props => (props.isDark ? white : black)};
  margin-bottom: 0;
  margin-left: auto;
  margin-right: ${stripUnit(spacing.medium) * 1.25 + 'px'};
  transition: color ${animationTime} ${animationCurve};

  ${media.medium`
    margin-right: ${spacing.large};
  `};
`

const HamburgerWrap = styled.div`
  color: ${props => (props.isDark ? white : black)};
`

const Menu = styled.div`
  ${mediaDown.medium`
    display: none;
  `};
`

const Details = ({ price, color, children, isDark, route, hidePrice }) => {
  return (
    <Portal selector={'misc'}>
      <Container isDark={isDark}>
        <Inner>
          <HamburgerWrap isDark={isDark}>
            <MobileNav />
          </HamburgerWrap>
          {!hidePrice && (
            <>
              <Price isDark={isDark}>
                <span>${price}</span>
              </Price>

              <Button to={route} theme="custom" customColor={color}>
                Buy now
              </Button>
            </>
          )}
        </Inner>
        <Menu>{children}</Menu>
      </Container>
    </Portal>
  )
}

Details.propTypes = {
  children: node.isRequired,
  price: string.isRequired,
  color: string.isRequired,
  isDark: bool,
  hidePrice: bool,
  route: string.isRequired
}

export default Details
